/**
 * Created by lu on 2018/5/8.
 */
var nb = require('../../../nb');
var View = require('../../../view/modal/login/Login');
var Model = nb.define({
    parent: require('../Dialog'),
    mapping: {
       form:require('../../../page/login/model/Form')
    },
    method: {
        init: function () {
            this.set('modalName', 'modal-login');

        },
        setData:function () {
            return {
                cn: {
                    title:'ASC Fine Wines',
                    form: {
                        idNum: {
                            inputBorder: 'login',
                            type: 'tel',
                            label:'手机号/邮箱/用户名',
                            isMust:'in',
                            placeholder: '请输入手机号或邮箱或用户名',
                            maxlength: '11'
                        },
                        password: {
                            inputBorder: 'login',
                            type: 'password',
                            label:'密码',
                            isMust:'in',
                            placeholder: '请输入密码'
                        },
                        button: {
                            btnColor:'btn-solid-gold',
                            btnSize: 'btn-lg',
                            text: '登录'
                        },
                        forget:'忘记密码？'
                    },
                    num: '没有账号？',
                    register: '点击注册'
                },
                en: {
                    title:'ASC Fine Wines',
                    form: {
                        idNum: {
                            inputBorder: 'login',
                            type: 'tel',
                            label:'Phone/Email/Account',
                            isMust:'in',
                            placeholder: 'Please enter your phone , email or account',
                            maxlength: '11'
                        },
                        password: {
                            inputBorder: 'login',
                            type: 'password',
                            label:'Password',
                            isMust:'in',
                            placeholder: 'Please enter your password'
                        },
                        button: {
                            btnColor:'btn-solid-gold',
                            btnSize: 'btn-lg',
                            text: 'Login'
                        },
                        forget:'Forgot Password？'
                    },
                    num: 'No Account？',
                    register: 'Register'
                }
            }
        }

    }
});
var model = new Model();
var view = new View;
view.setModel(model);
nb.model.onChange(nb.opts.clientReady, function () {
    view.$().appendTo(document.body);
}, this);

module.exports = model;


//////////////////
// WEBPACK FOOTER
// ../src/js/model/modal/login/Login.js
// module id = 514
// module chunks = 6